import { Box, Accordion } from "@simplybusiness/mobius";
import type { Upsell } from "../../types";
import { FileCirclePlus } from "../FileCirclePlus";
import { UpsellItem } from "./UpsellItem";
import type { DisplayVariant } from "../Coverage";
import { useSnowplowContext } from "@simplybusiness/services";

export type UpsellsProps = {
  upsells: Upsell[];
  displayVariant: DisplayVariant;
};

export const Upsells = ({ upsells, displayVariant }: UpsellsProps) => {
  const [firstUpsell, ...remainingUpsells] = upsells;
  const { snowplow } = useSnowplowContext();

  const onAccordionOpen = () => {
    const remainingUpsellsList = remainingUpsells
      .map(item => item.primaryText)
      .join(", ");

    snowplow?.trigger(`${displayVariant}UpsellAccordionClicked`, {
      label: remainingUpsellsList,
    });
  };

  return (
    <Box className="mobius-quote-card__upsells">
      <FileCirclePlus text="ADD-ONS AVAILABLE IN THE NEXT STEPS" />
      <div className="mobius-quote-card__upsells-first-upsell">
        <UpsellItem
          key={firstUpsell.primaryText}
          item={firstUpsell}
          displayVariant={displayVariant}
        />
      </div>
      {remainingUpsells.length > 0 && (
        <Accordion
          showText="View more available add-ons"
          hideText="Show less add-ons"
          onOpen={onAccordionOpen}
          headerPosition="bottom"
        >
          {remainingUpsells.map(item => (
            <UpsellItem
              key={item.primaryText}
              item={item}
              displayVariant={displayVariant}
            />
          ))}
        </Accordion>
      )}
    </Box>
  );
};
